import React, { useState } from 'react';
import { Label, OverviewHeader } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useQueryParam } from 'Hooks/useQueryParam';
import RuleTesterForm from 'Components/AddRulePage/RuleTester/RuleTesterForm';
import Results from './Results';

const RuleTester = ({
    formikProps,
    selectedRuleId,
    parameterData,
    listData,
    conclusionFlagListData,
    mode,
    currentRule,
    rulesType,
    overrideLevel
}: {
    formikProps?: any;
    selectedRuleId?: string;
    parameterData?: UseGetParametersResponse;
    listData?: ListApiGetResponse;
    conclusionFlagListData?: ConclusionListApiGetResponse[];
    mode: 'add' | 'edit' | 'read';
    currentRule?: any;
    rulesType?: RulesType;
    overrideLevel?: OverrideLevel;
}) => {
    const { t } = useTranslation();
    const [ruleTestId, setRuleTestId] = useState(null);
    const [isRuleTestRunning, setIsRuleTestRunning] = useState(false);
    const { parsed } = useQueryParam();
    let { mid: merchantId } = useParams<{ mid: string }>();
    let { tenantGroupId } = useParams<{ tenantGroupId: string }>();
    const ruleSetId = sessionStorage.getItem('ruleSetId') || '';
    merchantId = merchantId || (parsed.merchant as string) || '';
    tenantGroupId = tenantGroupId || (parsed.tenantGroupId as string) || '';
    let conditions = [];
    const ruleId = selectedRuleId || formikProps?.values.ruleId || '';
    const getListIds = (fieldName: string) => {
        const filteredlist =
            formikProps.values.lists.find((list: any) => {
                return list.fieldName === fieldName;
            }) || [];
        return filteredlist.listIds || [];
    };
    if (currentRule && currentRule.inputs) {
        conditions = currentRule.inputs.map((currentInput: any, index: number) => {
            const obj = {
                conditionId: index,
                fieldName: currentInput?.fieldName,
                operator: currentInput?.condition,
                tppType: parameterData?.fieldNameHashmap[currentInput.fieldName]?.tppType,
                values:
                    currentInput?.parameter.type === 'list'
                        ? getListIds(currentInput?.fieldName)
                        : [formikProps?.values[currentInput?.parameter.name]],
                readOnly: currentInput.readOnly
            };
            return obj;
        });
    }

    return (
        <OverviewHeader dataTestId='rule-tester' leftTitle={t('Rule Test')}>
            <Label label={t('ruleTesterInfo')} id='rule-tester-info' />
            {!selectedRuleId && (
                <RuleTesterForm
                    parameterData={parameterData}
                    formikProps={formikProps}
                    setRuleTestId={setRuleTestId}
                    isRuleTestRunning={isRuleTestRunning}
                    setIsRuleTestRunning={setIsRuleTestRunning}
                    conditions={conditions}
                    merchantId={merchantId}
                    tenantGroupId={tenantGroupId}
                    ruleSetId={ruleSetId}
                    mode={mode}
                    rulesType={rulesType}
                    overrideLevel={overrideLevel}
                    outputDescriptor={currentRule?.outputDescriptor || ''}
                />
            )}
            <Results
                ruleId={ruleId}
                ruleTestId={ruleTestId}
                parameterData={parameterData}
                listData={listData}
                conclusionFlagListData={conclusionFlagListData}
                mode={mode}
                setIsRuleTestRunning={setIsRuleTestRunning}
                merchantId={merchantId}
                tenantGroupId={tenantGroupId}
                ruleSetId={ruleSetId}
                overrideLevel={overrideLevel}
                isRuleTestRunning={isRuleTestRunning}
            />
        </OverviewHeader>
    );
};

export default RuleTester;
